export const endpoints = {
	events: {
		export: "/events/export",
		get: "/events",
		getById: (eventId: string) => `/events/${eventId}`,
		getNotifications: (eventId: string) => `/events/${eventId}/notifications`,
		getVideos: (eventId: string) => `/events/${eventId}/video`,
		history: (eventId: string) => `/events/${eventId}/history`,
		read: (eventId: string) => `/events/${eventId}/read`,
		reanalysis: (eventId: string) => `/events/${eventId}/reanalysis`,
		reanalysisCheck: (eventId: string, reanalysisId: string) =>
			`/events/${eventId}/reanalysis/${reanalysisId}/check`,
		reanalysisForce: (eventId: string, reanalysisId: string) =>
			`/events/${eventId}/reanalysis/${reanalysisId}/force`,
		reanalysisRevert: (eventId: string, reanalysisId: string) =>
			`/events/${eventId}/reanalysis/${reanalysisId}/revert`,
		reanalysisSuggest: (eventId: string) =>
			`/events/${eventId}/reanalysis/suggest`,
		sendNotifications: (eventId: string) => `/events/${eventId}/notifications`,
		stats: "/events/stats",
		updateDetails: (eventId: string) => `/events/${eventId}`,
		updateStatus: (eventId: string) => `/events/${eventId}/status`,
		updateTypes: (eventId: string) => `/events/${eventId}/types`,
	},
	exports: {
		download: (exportId: string) => `/exports/${exportId}/download`,
		list: "/exports",
	},
	floors: {
		create: "/floors",
		list: "/floors",
		update: (floorId: string) => `/floors/${floorId}`,
	},
	installations: {
		get: "/installations",
	},
	locations: {
		create: "/locations",
		delete: (locationId: string) => `/locations/${locationId}`,
		get: "/locations",
		getById: (locationId: string) => `/locations/${locationId}`,
		update: (locationId: string) => `/locations/${locationId}`,
	},
	me: {
		get: "/me",
		update: "/me",
	},
	reanalysis: {
		classes: "/reanalysis/classes",
	},
	sensors: {
		create: "/sensors",
		delete: (sensorId: string) => `/sensors/${sensorId}`,
		get: "/sensors",
		getById: (sensorId: string) => `/sensors/${sensorId}`,
		getByLocation: (locationId: string) => `/sensors?location=${locationId}`,
		getByLocations: (locationIds: string[]) =>
			`/sensors?location=${locationIds.join(",")}`,
		getByZone: (zoneId: string) => `/sensors?zone=${zoneId}`,
		liveStatus: "/sensors/status",
		summary: "/sensors/summary",
		update: (sensorId: string) => `/sensors/${sensorId}`,
	},
	users: {
		cancelInvite: (userId: string) => `/users/${userId}/invite`,
		create: "/users",
		delete: (userId: string) => `/users/${userId}`,
		get: "/users",
		getById: (userId: string) => `/users/${userId}`,
		invite: "/users/invite",
		update: (userId: string) => `/users/${userId}`,
		updatePermissions: (userId: string) => `/users/${userId}/permissions`,
		updateStatus: (userId: string) => `/users/${userId}/status`,
	},
	watches: {
		create: "/watches",
		get: "/watches",
		getById: (watchId: string) => `/watches/${watchId}`,
		update: (watchId: string) => `/watches/${watchId}`,
	},
	zones: {
		create: "/zones",
		// TODO: Add delete: (zoneId) => `/zones/${zoneId}` when zone delete API exists
		get: (locationId: string) => `/locations/${locationId}/zones`,
		update: (zoneId: string) => `/zones/${zoneId}`,
	},
};
